import { IApplicationState } from '../../types/redux';
import { getRegionId } from '../currentRegion';

export const getMortgageBannerUrl = (state: IApplicationState): string => {
  const regionId = getRegionId(state);

  return `/cat.php/?deal_type=sale&engine_version=2&from_developer=1&offer_type=flat&is_discount_mortgage=1&region=${regionId}`;
};
